import { render, staticRenderFns } from "./PointFamily.vue?vue&type=template&id=42bff633&scoped=true&"
import script from "./PointFamily.vue?vue&type=script&lang=js&"
export * from "./PointFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bff633",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bff633')) {
      api.createRecord('42bff633', component.options)
    } else {
      api.reload('42bff633', component.options)
    }
    module.hot.accept("./PointFamily.vue?vue&type=template&id=42bff633&scoped=true&", function () {
      api.rerender('42bff633', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/Points/PointFamily.vue"
export default component.exports